import React from "react";
import PageShell from "@/components/PageShell";

const SECTIONS = [
  {
    h: "1. Information we collect",
    p: "We collect the information you give us when you create an account (name and email), complete onboarding (your social handles, niche, target audience and starting follower counts), and use the product (follower logs you enter, goals, calendar entries, and content you generate). If you subscribe, our payment processor collects your billing details — we never store your full card number.",
  },
  {
    h: "2. How we use your information",
    p: "We use your information to run your growth campaign, personalize AI content suggestions, show your analytics, send the emails you opt into (weekly recaps, reminders and important account notices), provide support, and process payments. We do not sell your personal information.",
  },
  {
    h: "3. Your social accounts",
    p: "CloutRise never asks for the passwords to your TikTok, Instagram, YouTube or Facebook accounts. Follower and growth data is either self-logged by you or projected by our models. We cannot post to or access your social accounts on your behalf.",
  },
  {
    h: "4. Third-party services",
    p: "We rely on trusted providers to operate: Stripe for payments, Resend for email delivery, and AI providers to power content generation. These providers process only the data needed to deliver their part of the service, under their own security and privacy commitments.",
  },
  {
    h: "5. Emails and communications",
    p: "You control your email preferences at any time from your dashboard — weekly recaps, best-day digests and daily reminders can each be turned off. We will still send essential account and billing notices while your subscription is active.",
  },
  {
    h: "6. Data retention",
    p: "We keep your account data for as long as your account is active. You can request deletion of your account and associated data at any time by contacting us, and we will remove it except where we are required to retain records (for example, billing history) by law.",
  },
  {
    h: "7. Security",
    p: "We use industry-standard measures to protect your data, including encrypted connections (HTTPS) and hashed passwords. No system is perfectly secure, but we work continuously to safeguard your information.",
  },
  {
    h: "8. Your rights",
    p: "Depending on where you live, you may have the right to access, correct, export or delete your personal data. To exercise any of these rights, email us and we'll respond promptly.",
  },
  {
    h: "9. Changes to this policy",
    p: "We may update this policy from time to time. When we make material changes, we'll update the date below and, where appropriate, notify you by email.",
  },
  {
    h: "10. Contact us",
    p: "Questions about your privacy? Email support@clout-rise.com and we'll be glad to help.",
  },
];

const Privacy = () => (
  <PageShell
    testid="privacy-page"
    kicker="Legal"
    title="Privacy Policy"
    subtitle="How CloutRise collects, uses and protects your information."
  >
    <p className="text-sm text-muted-foreground mb-10">Last updated: June 2026</p>
    <div className="space-y-8">
      {SECTIONS.map((s) => (
        <div key={s.h}>
          <h2 className="font-heading text-xl font-bold mb-2">{s.h}</h2>
          <p className="text-muted-foreground leading-relaxed">{s.p}</p>
        </div>
      ))}
    </div>
  </PageShell>
);

export default Privacy;
